import React from "react";
import styles, { elements } from "../../pages/styles";
import { TypeAnimation } from "react-type-animation";
import { freetrialhero, freetrialheromobile, teacherzoom, textlogo } from "../../assets/images";
import { ArrowRight } from "lucide-react";

const FreeTrialHero = ({ title, desc, img, bgcolor }) => {
  return (
    <div className="flex flex-col-reverse md:flex-row w-full rounded-t-xl relative -mt-4 md:-mt-14">
        
    {/* LEFT SECTION (Hero Images) */}
    <div className="relative w-full md:w-1/2 md:min-h-[550px]">
      {/* Desktop hero (hidden on mobile) */}
      <img
        src={freetrialhero}
        alt="Free Trial Hero (Desktop)"
        className="
          hidden 
          md:block 
          w-full 
          overflow-visible
          h-full
          min-h-[550px]
          object-cover
          object-center
        "
      />
      {/* Mobile hero (hidden on desktop) */}
      <img
        src={freetrialheromobile}
        alt="Free Trial Hero (Mobile)"
        className="
          block
          md:hidden
          w-full
          h-auto
          object-cover
          object-center
        "
      />

      {/* Teacher Zoom (absolutely positioned to overlap) */}
      <img
        src={teacherzoom}
        alt="Teacher Zoom"
        className="
          teacherZoomImg
          zoomImg
          md:w-60
          w-40
          absolute              
          transform
        "
      />
    </div>

    {/* RIGHT SECTION (Logos, Heading, CTA) */}
    <div
      className="
        px-6
        md:px-8
        py-8
        md:py-12
        flex 
        flex-col 
        items-center 
        md:items-start 
        z-10
        justify-center 
        text-center 
        md:text-left
      "
    >
      {/* Logo */}
      <div className="mb-6">
        <img
          src={textlogo}
          alt="Tech Tails Logo"
          className="w-auto h-auto min-w-[120px]"
        />
      </div>

      <h1 className={`${styles.biggerheadingdark} mb-5 leading-tight`}>
        Unlock Your Child's
        <br className="hidden sm:inline" />
        <span className="relative inline-block">
        Future
        <span className="absolute shadow-sm bottom-0 left-1 w-full h-2 bg-pinkprimary/70 -z-10 -skew-x-[30deg] rounded-sm"></span>
        </span>
        <br className="sm:hidden" />
        {" "}In{" "}
        <TypeAnimation
          repeat={Infinity}
          speed={5}
          sequence={[
            "Technology",
            2000,
            "Programming",
            2000,
            "Creativity",
            2000,
            "Learning",
            2000,
            "Game Design",
            2000,
            "Coding",
            1500,
            "Digital Art",
            2000,
          ]}
        />
      </h1>

      <p className={`${styles.paragraph} mb-6 max-w-xl leading-relaxed`}>
        Live 1-on-1 instruction tailored to your child's interests. 
        Learn coding, game design, and more with expert teachers.
      </p>

      {/*
        CHANGED: Use an anchor link so that clicking it scrolls to the
        "Try Before Anything!" section below instead of going to /pages/freetrial
      */}
      <a
        className={`${elements.bluebutton} flex items-center justify-center gap-2 border-b-[5px] border-orangeprimary shadow-lg hover:shadow-xl transition-shadow w-full md:w-auto`}
        href="#trialClass"
      >
        Get Free Trial Class
        <ArrowRight size={18} />
      </a>
    </div>
  </div>
  );
};

export default FreeTrialHero;
